<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()

const title = computed(() => props.data?.title || '')
const sub_title = computed(() => props.data?.sub_title || '')
</script>

<template>
<div class="table-cell contract-subject-cell">
  <h3>{{title}}</h3>
  <p>{{sub_title}}</p>
</div>
</template>

<style lang="scss">
.contract-subject-cell{
  display: flex;
  flex-direction: column;

  word-break: keep-all;
  white-space: nowrap;

  h3{
    font-weight: bold;
    font-size: 13px;
    text-transform: capitalize;
  }
}
</style>
